import { Injectable } from '@angular/core';
import { AgCellLocalStoreService, AgCellState } from '../../../../global/gx-ag-grid/ag-cell-local-store.service';
import { map } from 'rxjs/operators';
import { LocationListLocalStoreService } from '../../location-list-local-store.service';
import { Observable } from 'rxjs';
import { ICellRendererParams } from 'ag-grid-community';
import { Location } from '../../../../../models/locations-models/location';

interface CcCompletionCellState extends AgCellState {}

@Injectable({
  providedIn: 'root'
})
export class CcCompletionCellLocalStoreService extends AgCellLocalStoreService<CcCompletionCellState> {

  readonly canToggleCcCompletion$ = this.params$.pipe(map((params) => {
    const location: Location = params.data;
    if (location?.claimAndCleanCompletionTimestamp !== null) {
      return true;  // unmarking should always be possible
    }
    return location?.foundInMyBusiness || location?.managementStatus === 'NOT_MANAGED';
  }));

  readonly tooltip$ = this.select(this.params$,
      this.canToggleCcCompletion$,
      (params, canToggleCcCompletion) => {
        const location: Location = params.data;
        if (!canToggleCcCompletion) {
          return 'Location needs to be linked to a GBP location or not being managed by us before it can be marked as completed.';
        }
        return (location.claimAndCleanCompletionTimestamp !== null ? 'Unmark' : 'Mark') + ' as completed';
      });

  readonly isLoading$ = this.select(this.params$,
      this.locationListLocalStore.loadingCcCompletion$,
      (params, loadingCcCompletion) => {
        const location: Location = params.data;
        return loadingCcCompletion[location?.id];
  })

  readonly viewModel$: Observable<{
    params: ICellRendererParams<Location>,
    isLoading: boolean,
    tooltip: string,
    canToggleCcCompletion: boolean
  }> = this.select({
    params: this.params$,
    isLoading: this.isLoading$,
    tooltip: this.tooltip$,
    canToggleCcCompletion: this.canToggleCcCompletion$
  })



  constructor(private locationListLocalStore: LocationListLocalStoreService) {
    super({
      cellValue: '',
      params: null,
    })
  }
}
